import { casingUtil } from '@/utils'
import { Livestream, ServerLivestream } from './types'

export const resolveLivestreamDown = ({ ...rest }: ServerLivestream) =>
  ({
    ...(casingUtil.snakeToCamel(rest) as Livestream),
  } as Livestream)
